import { Card, CardHeader, Grid, Typography } from "@mui/material";
import React from "react";
import { MdOutlineInventory2 } from "react-icons/md";
import UserProductCountTable from "./home/table";

const UserProductCounts = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title={
              <Typography variant="h4" component="div">
                سجل الذمم
              </Typography>
            }
            avatar={<MdOutlineInventory2 size={20} />}
          />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <UserProductCountTable />
      </Grid>
    </Grid>
  );
};

export default UserProductCounts;
